import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { StatusBadge } from '../../../components/status/StatusBadge';
import clsx from 'clsx';
import { numberFormatter, numberFormatterCount } from '../../../utils/utilities';
import { IPartnerCommissions } from '../../order/order-interfaces';
import { CommissionsPost } from '../../../components/agents/CommissionsPost';

export enum PartnersCommissionsDataTableAccessorKeys {
	name = 'partnerName',
	activeMerchants = 'activeMerchantsCount',
	commissionOnGrossRevenueAmount = 'commissionOnGrossRevenueAmount',
	commissionOnNetRevenueAmount = 'commissionOnNetRevenueAmount',
	commissionOnVolume = 'commissionOnVolume',
	total = 'commissionTotalAmount',
	status = 'status',
	id = 'id',
}

export const defaultPartnersCommissionsColumnSizing: ColumnSizing = {
	[PartnersCommissionsDataTableAccessorKeys.name]: 100,
	[PartnersCommissionsDataTableAccessorKeys.activeMerchants]: 100,
	[PartnersCommissionsDataTableAccessorKeys.commissionOnGrossRevenueAmount]: 100,
	[PartnersCommissionsDataTableAccessorKeys.commissionOnNetRevenueAmount]: 100,
	[PartnersCommissionsDataTableAccessorKeys.commissionOnVolume]: 100,
	[PartnersCommissionsDataTableAccessorKeys.total]: 100,
	[PartnersCommissionsDataTableAccessorKeys.status]: 100,
	[PartnersCommissionsDataTableAccessorKeys.id]: 50,
};

export const defaultPartnersCommissionsColumns: MRT_ColumnDef<IPartnerCommissions>[] = [
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{/*<Link*/}
				{/*	to={`#`}*/}
				{/*	target="_blank"*/}
				{/*	className="text-black fw-bolder cursor-pointer main-font-family text-primary fc-merchant-name-link fc-text-overflow"*/}
				{/*>*/}
				{/*	{renderedCellValue}*/}
				{/*	<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-2 w-10px"/>*/}
				{/*</Link>*/}
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.activeMerchants,
		header: 'Active merchants',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Active merchants</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue ? numberFormatterCount(renderedCellValue) : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.commissionOnGrossRevenueAmount,
		header: 'Commissions on gross revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on gross revenue</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue
						?`${row?.original?.currencySymbol}${numberFormatter(renderedCellValue/100)}`
						: '-'
					}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.commissionOnNetRevenueAmount,
		header: 'Commissions on net revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on net revenue</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue
						?`${row?.original?.currencySymbol}${numberFormatter(renderedCellValue/100)}`
						: '-'
					}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.commissionOnVolume,
		header: 'Commissions on volume',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on volume</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue ? numberFormatterCount(renderedCellValue) : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.total,
		header: 'Total commissions',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Total commissions</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue
						?`${row?.original?.currencySymbol}${numberFormatter(renderedCellValue/100)}`
						: '-'
					}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow">
					<StatusBadge
						badgeContent={renderedCellValue}
						additionalClasses={clsx(renderedCellValue === 'Unpaid' && 'badge-cancelled' )}
					/>
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: PartnersCommissionsDataTableAccessorKeys.id,
		header: 'Action',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Action</span>,
		Cell: ({ table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{/*<ButtonComponent*/}
				{/*	buttonType={BUTTON_TYPE.WHITE}*/}
				{/*	buttonName='Post'*/}
				{/*	isDisabled={row?.original?.status !== 'Unpaid'}*/}
				{/*	additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3"*/}
				{/*/>*/}
				<CommissionsPost status={row?.original?.status} id={row?.original?.pid}/>
			</TableCell>
		)
	},
];

export interface IMockProps {
	name: string,
	activeMerchants: number,
	grossRevenue: number,
	netRevenue: number,
	total: number,
	transactions: number,
	status: number,
	id: string,
}

export const mockPartnersCommissionsData: IMockProps[] = [
	{
		name: 'Sticky',
		activeMerchants: 33,
		grossRevenue: 5028,
		netRevenue: 9107.90,
		total: 2100.26,
		transactions: 2100.26,
		status: 1,
		id: '1',
	},
	{
		name: 'Payway',
		activeMerchants: 2,
		grossRevenue: 5028,
		netRevenue: 9107.90,
		total: 2600.26,
		transactions: 2600.26,
		status: 2,
		id: '2',
	},
	{
		name: 'Linkmedia',
		activeMerchants: 16,
		grossRevenue: 5028,
		netRevenue: 9107.90,
		total: 2700.26,
		transactions: 2700.26,
		status: 2,
		id: '3',
	},
	{
		name: 'Paypal',
		activeMerchants: 156,
		grossRevenue: 5028,
		netRevenue: 9107.90,
		total: 657700.26,
		transactions: 657700.26,
		status: 1,
		id: '4',
	},
	{
		name: 'Vogaro',
		activeMerchants: 42,
		grossRevenue: 5028,
		netRevenue: 9107.90,
		total: 36700.26,
		transactions: 36700.26,
		status: 1,
		id: '5',
	},

];
